module.exports = __webpack_public_path__ + "static/media/btn_apple_kr.03dd9d2f.png";